import { defineStore } from "pinia";
import { v4 as uuidv4 } from 'uuid';

export const useRowsStore = defineStore("rows", {
  state: () => ({
    weeks: {},
  }),
  actions: {
    getWeek(weekStart) {
      if (!this.weeks[weekStart]) {
        this.weeks[weekStart] = this.generateWeek(weekStart);
      }
      return this.weeks[weekStart];
    },
    generateWeek(weekStart) {
      const days = [];
      const startDate = new Date(weekStart);
      const dayNames = [
        "Dilluns",
        "Dimarts",
        "Dimecres",
        "Dijous",
        "Divendres",
      ];

      for (let i = 0; i < 5; i++) {
        const currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        days.push({
          date: currentDate.toLocaleDateString("es-ES"),
          dayName: dayNames[i],
          rows: [],
        });
      }
      return days;
    },
    addRow(weekStart, dayIndex) {
      this.weeks[weekStart][dayIndex].rows.push({
        id: uuidv4(),
        site: "",
        ticket: "",
        ticketUrl: "",
        entrada: "",
        final: "",
        temps: "",
        inputat: false,
      });
    },
    deleteRow(weekStart, dayIndex, rowIndex) {
      this.weeks[weekStart][dayIndex].rows.splice(rowIndex, 1);
    },
  },
  persist: true,
});
